import { Card, CardContent, CardHeader, Grid, IconButton, Box, Button, Typography } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { useFormContext } from 'react-hook-form';
import { FormTextField } from 'shared/controls';
import { OrderNoteForm } from 'shared/types';
import { buildFieldOrderNoteNameWithIndex } from 'shared/utility';

interface OrderNotesFieldsProps {
  index: number;
  remove: (index: number) => () => void;
  isLastOrderNote: boolean;
  addOrderNote: () => void;
}
export function OrderNotesFields({ index, remove, isLastOrderNote, addOrderNote }: OrderNotesFieldsProps) {
  const {
    formState: { errors },
  } = useFormContext();

  const buildFieldName = buildFieldOrderNoteNameWithIndex<OrderNoteForm>(index);

  const CardSubHeader = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={theme => ({
          marginRight: theme.spacing(2),
        })}
      >
        {`#${index + 1}`}
      </Typography>
    </Box>
  );

  return (
    <Grid xs={12} item>
      <Card>
        <CardHeader
          action={
            <IconButton onClick={remove(index)}>
              <Delete />
            </IconButton>
          }
          subheader={<CardSubHeader />}
        />
        <CardContent>
          <Grid container spacing={1}>
            <Grid xs={12} item>
              <FormTextField
                name={buildFieldName('note')}
                label='Notes'
                rules={{
                  required: {
                    message: 'Notes are required',
                    value: true,
                  },
                }}
                error={Boolean(errors?.orderNotes?.[index]?.note)}
                helperText={errors?.orderNotes?.[index]?.note?.message}
              />
            </Grid>
          </Grid>
          {isLastOrderNote && (
            <Button
              sx={{ marginTop: '25px' }}
              onClick={addOrderNote}
              variant='outlined'
              startIcon={<Add fontSize='large' />}
            >
              add order notes
            </Button>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}
